import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { RenameSurveyLanguageRPC } from "./renameSurveyLanguageRPC";

export class RenameSurveyLanguageRPCClientImpl extends RenameSurveyLanguageRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: RenameSurveyLanguageRPC.Request): Promise<LeoRPCResult<RenameSurveyLanguageRPC.Response, RenameSurveyLanguageRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/RenameSurveyLanguage",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      RenameSurveyLanguageRPC.ResponseDTO,
      RenameSurveyLanguageRPC.Errors.ErrorsDTO,
      RenameSurveyLanguageRPC.Response,
      RenameSurveyLanguageRPC.Errors.Errors
    >(
      response,
      "survey/RenameSurveyLanguage",
      RenameSurveyLanguageRPC.Response.fromDTO,
      RenameSurveyLanguageRPC.Errors.fromDTO
    );
  }
}
